import { AUTHENTICATION_ROUTES, isAuthRoute } from "./authentication";
import { CRM_ROUTES } from "./crm";
import { DASHBOARD_ROUTES } from "./dashboard";
import { DIRECTOR_ROUTES } from "./director";
import { GENERAL_ROUTES } from "./general";
import { ISSUES_ROUTES } from "./issues";
import { LANGUAGES_ROUTES } from "./languages";
import { MAILING_ROUTES } from "./mailing";
import { PAYMENTS_ROUTES } from "./payments";
import { PROMOCODES_ROUTES } from "./promocodes";
import { TRANSLATIONS_ROUTES } from "./translations";

export const ROUTES = [
    ...AUTHENTICATION_ROUTES,
    ...DASHBOARD_ROUTES,
    ...DIRECTOR_ROUTES,
    ...GENERAL_ROUTES,
    ...PAYMENTS_ROUTES,
    ...TRANSLATIONS_ROUTES,
    ...LANGUAGES_ROUTES,
    ...MAILING_ROUTES,
    ...PROMOCODES_ROUTES,
    ...CRM_ROUTES,
    ...ISSUES_ROUTES,
];

export { isAuthRoute };
